/* CUSTOM KIYO START — kiyo-lp-teile.js (2026-10-06)
   Markers on the photo of sections/kiyo-lp-teile.liquid grow into a card with the part (Jonathan 06.10.).
   The card is anchored at its marker (grows right/down, or left/up near the edges) and stays inside the photo,
   so it never covers the parts list below. The inner box is clipped from the marker's rectangle to the full card
   and back on close. One card at a time; closes on ×, Escape, a tap outside or the marker again (keyboard).
   07.10.: opening moves the focus into the card (its link), closing with × or Escape returns it to the marker; Tab out
   of the card closes it (the open marker is invisible). Resizing closes only when the width changes (phone address bar). */
(function () {
  var RAND = 8;
  var DAUER = 340;

  function rect(el, base) {
    var r = el.getBoundingClientRect();
    return { l: r.left - base.left, t: r.top - base.top, r: r.right - base.left, b: r.bottom - base.top, w: r.width, h: r.height };
  }

  function karteZu(marke) { return document.getElementById(marke.getAttribute('aria-controls')); }

  // Clip of the inner box that matches the marker, in the card's own coordinates
  function startClip(m, k) {
    return 'inset(' + Math.max(0, m.t - k.t) + 'px ' + Math.max(0, k.r - m.r) + 'px ' + Math.max(0, k.b - m.b) + 'px ' + Math.max(0, m.l - k.l) + 'px round 8px)';
  }

  function open(marke) {
    var root = marke.closest('.klt');
    var karte = karteZu(marke);
    if (!root || !karte) return;
    schliessen(root, true);
    var innen = karte.querySelector('.klt__karte-innen');
    karte.hidden = false;
    var foto = karte.offsetParent;
    var f = foto.getBoundingClientRect();
    var m = rect(marke, f);
    var kw = karte.offsetWidth;
    var kh = karte.offsetHeight;
    // Grow from a corner of the marker (right/down first); pick the direction that covers the fewest other markers
    var andere = Array.prototype.filter.call(root.querySelectorAll('.klt__marke'), function (x) { return x !== marke; })
      .map(function (x) { return rect(x, f); });
    var klemm = function (v, max) { return Math.min(Math.max(v, RAND), max - RAND); };
    var beste = null;
    [[m.l, m.t], [m.r - kw, m.t], [m.l, m.b - kh], [m.r - kw, m.b - kh]].forEach(function (p) {
      var l = klemm(p[0], f.width - kw);
      var t = klemm(p[1], f.height - kh);
      var flaeche = andere.reduce(function (sum, o) {
        var w = Math.min(l + kw, o.r) - Math.max(l, o.l);
        var h = Math.min(t + kh, o.b) - Math.max(t, o.t);
        return sum + (w > 0 && h > 0 ? w * h : 0);
      }, 0);
      if (!beste || flaeche < beste.flaeche) beste = { l: l, t: t, flaeche: flaeche };
    });
    var left = beste.l;
    var top = beste.t;
    karte.style.left = left + 'px';
    karte.style.top = top + 'px';
    var k = { l: left, t: top, r: left + kw, b: top + kh };
    var clip = startClip(m, k);
    karte.dataset.kltClip = clip;
    innen.style.transition = 'none';
    innen.style.clipPath = clip;
    innen.getBoundingClientRect();
    innen.style.transition = '';
    innen.style.clipPath = 'inset(0 round 12px)';
    karte.classList.add('is-offen');
    marke.classList.add('is-offen');
    marke.setAttribute('aria-expanded', 'true');
    var ziel = karte.querySelector('.klt__karte-link') || karte.querySelector('[data-klt-zu]');
    if (ziel) ziel.focus({ preventScroll: true });
  }

  function zu(marke, sofort) {
    var karte = karteZu(marke);
    marke.setAttribute('aria-expanded', 'false');
    marke.classList.remove('is-offen');
    if (!karte) return;
    var innen = karte.querySelector('.klt__karte-innen');
    karte.classList.remove('is-offen');
    if (sofort) { karte.hidden = true; return; }
    innen.style.clipPath = karte.dataset.kltClip || '';
    window.setTimeout(function () {
      if (marke.getAttribute('aria-expanded') !== 'true') karte.hidden = true;
    }, DAUER);
  }

  function schliessen(root, sofort) {
    root.querySelectorAll('[data-klt-marke][aria-expanded="true"]').forEach(function (m) { zu(m, sofort); });
  }

  document.addEventListener('click', function (event) {
    var marke = event.target.closest('[data-klt-marke]');
    if (marke) {
      if (marke.getAttribute('aria-expanded') === 'true') zu(marke);
      else open(marke);
      return;
    }
    var knopf = event.target.closest('[data-klt-zu]');
    if (knopf) {
      var karte = knopf.closest('[data-klt-karte]');
      var m = karte && document.querySelector('[aria-controls="' + karte.id + '"]');
      if (m) { zu(m); m.focus(); }
      return;
    }
    if (!event.target.closest('[data-klt-karte]')) {
      document.querySelectorAll('.klt').forEach(function (root) { schliessen(root); });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var offen = document.querySelector('.klt [data-klt-marke][aria-expanded="true"]');
    if (!offen) return;
    var karte = karteZu(offen);
    var drin = document.activeElement === offen || (karte && karte.contains(document.activeElement));
    zu(offen);
    if (drin) offen.focus();
  });

  // Focus leaves an open card (Tab / Shift+Tab): close it, the focus stays where it went
  document.addEventListener('focusout', function (event) {
    var karte = event.target.closest && event.target.closest('[data-klt-karte]');
    var nach = event.relatedTarget;
    if (!karte || karte.hidden || !nach || karte.contains(nach)) return;
    var m = document.querySelector('[aria-controls="' + karte.id + '"]');
    if (m && m.getAttribute('aria-expanded') === 'true') zu(m);
  });

  var breite = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === breite) return;
    breite = window.innerWidth;
    var drin = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-klt-karte]');
    document.querySelectorAll('.klt').forEach(function (root) { schliessen(root, true); });
    var m = drin && document.querySelector('[aria-controls="' + drin.id + '"]');
    if (m) m.focus({ preventScroll: true });
  });
})();
/* CUSTOM KIYO END */
